import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { values, contains } from "ramda"
import Actions from "../../redux/wizard.redux"

import StepOne from "./step-one.component"
import StepTwo from "./step-two.component"
import StepThree from "./step-three.component"
import StepFour from "./step-four.component"
import StepFive from "./step-five.component"
import StepSix from "./step-six.component"
import Box from "../../lib/ui/ui-box"

const MAP_QUESTIONS_TO_PAGE = {
  1: "What is the estimated property value of your home?",
  2: "What is your property address?",
  3: "What is the name and age of the youngest applicant ?",
  4: "What is your contact information?",
  5: "Have you consulted about getting an Equity Release Mortgage?",
  6: "Thank you"
}

class WizardForm extends Component {
  componentDidMount() {
    this.handleOnViewed()
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.page !== prevProps.match.params.page) {
      this.handleOnViewed()
    }
  }

  nextPage = () => {
    const { history, match, intl } = this.props
    const page = Number(match.params.page)
    this.handleOnUpdatedAnswer()
    history.push(`${intl.formatMessage({ id: "routes.reverse" })}/${page + 1}`)
  }

  previousPage = () => {
    const { history, match, intl } = this.props
    const page = Number(match.params.page)
    history.push(`${intl.formatMessage({ id: "routes.reverse" })}/${page - 1}`)
  }

  handleOnUpdatedAnswer = () => {
    const { match } = this.props
    const page = Number(match.params.page)
    this.props.analyticsQuestionAnswered(page, {
      eventName: "updated answer",
      category: "questions",
      label: `${page} | ${MAP_QUESTIONS_TO_PAGE[page]}`,
      location: "reserve mortgage flow",
      question_id: page,
      question_name: MAP_QUESTIONS_TO_PAGE[page],
      step: page
    })
  }

  handleOnViewed = () => {
    const { match } = this.props
    const page = Number(match.params.page)
    this.props.analyticsQuestionViewed(page, {
      eventName: "viewed question",
      category: "questions",
      label: `${page} | ${MAP_QUESTIONS_TO_PAGE[page]}`,
      location: "reserve mortgage flow",
      question_id: page,
      question_name: MAP_QUESTIONS_TO_PAGE[page],
      step: page
    })
  }

  render() {
    const { match, stepValidationMap } = this.props
    const isFlowInvalid = contains(false, values(stepValidationMap))
    const page = Number(match.params.page)

    return (
      <Box flexDirection="column" pl={[4]}>
        <Box mb={[3]}>
          {match.params.page === "1" && (
            <StepOne {...this.props} onSubmit={this.nextPage} />
          )}
          {match.params.page === "2" && (
            <StepTwo {...this.props} onSubmit={this.nextPage} />
          )}
          {match.params.page === "3" && (
            <StepThree {...this.props} onSubmit={this.nextPage} />
          )}
          {match.params.page === "4" && (
            <StepFour {...this.props} onSubmit={this.nextPage} />
          )}
          {match.params.page === "5" && (
            <StepFive
              {...this.props}
              isFlowInvalid={isFlowInvalid}
              onSubmit={() => {
                this.nextPage()
                this.props.analyticsIdentify()
              }}
            />
          )}
          {match.params.page === "6" && (
            <StepSix
              {...this.props}
              onSubmit={() => {
                this.handleOnUpdatedAnswer()
              }}
            />
          )}
        </Box>
      </Box>
    )
  }
}

WizardForm.propTypes = {
  stepValidationMap: PropTypes.object.isRequired
}

const mapDispatchToProps = dispatch => {
  return {
    submit: () => dispatch(Actions.submitRenewal()),
    analyticsQuestionAnswered: (currentStep, value) =>
      dispatch(
        Actions.analyticsQuestionAnswered(
          "REVERSE_MORTGAGE",
          currentStep,
          value
        )
      ),
    analyticsQuestionViewed: (currentStep, value) =>
      dispatch(
        Actions.analyticsQuestionViewed("REVERSE_MORTGAGE", currentStep, value)
      ),
    analyticsIdentify: eventPaylod =>
      dispatch(Actions.analyticsIdentify(eventPaylod))
  }
}
export default connect(null, mapDispatchToProps)(WizardForm)



// WEBPACK FOOTER //
// ./src/components/renewal-wizard/renewal-wizard.component.js